import useAPI from '@/hooks/useAPI';
import EpisodeOfCareRepository from '@/repositories/EpisodeOfCareRepository/EpisodeOfCareRepository';

const useDischargeReasons = (enabled = true) => {
  const episodeOfCareRepository = EpisodeOfCareRepository();

  return useAPI({
    queryKey: ['getDischargeReasons'],
    queryFn: async () => {
      return await episodeOfCareRepository.getDischargeReasons();
    },
    enabled
  });
};

export default useDischargeReasons;
